/**
 * @namespace Stores
 * @category Stores
 * @module reference-circuit
 * */

const initialState = {
  toggleVisibilityLoading: false,
}

export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  getters: {
    isToggleVisibilityLoading: (state) => state.toggleVisibilityLoading,
  },
  mutations: {
    setToggleVisibilityLoading(state, payload) {
      state.toggleVisibilityLoading = payload
    },
  },
}
